import React from 'react';
import RecentBetting from "../bet/RecentBetting";
import {useRoulette} from "../../../store/roulette/RouletteContext";

const RecentTicketMobile = () => {
    const props = useRoulette()
    return  <RecentBetting {...props}/>
};

export default RecentTicketMobile;